import { screenTypeDropdowns } from "./slideTemplateAllocation";
import { pictograms } from "./pictograms";

/**
 * LWcustom - Modify this array to include any models that have special display names
 */
export const customTitles = [
  {
    original: "templateCustomTitle",
    display: "Template Custom Title",
  },
  {
    original: "schoolphotos",
    display: "School Photos",
  },
  {
    original: "studentworks",
    display: "Student Work",
  },
];

export interface IDropdownOption {
  label?: string;
  value: string | number;
}

export interface IDropdownMapping {
  model: string;
  field: string;
  options: IDropdownOption[];
}

/**
 * Custom dropdown options. Forms will intercept these models and fields to add dropdown options to them
 */
export const dropdownFields: IDropdownMapping[] = [
  {
    model: "modelName - example item",
    field: "fieldName or ColumnName",
    options: [
      { label: "what shows on the dropdown", value: "optionValue" },
      { label: "label", value: "value" },
    ],
  },
  {
    model: "users",
    field: "user_role",
    options: [
      { label: "Admin", value: "admin" },
      { label: "Editor", value: "editor" },
    ],
  },
  {
    model: "studentworks",
    field: "type",
    options: [
      { label: "Image", value: "Image" },
      { label: "Video", value: "Video" },
    ],
  },
  {
    model: "schoolphotos",
    field: "type",
    options: [
      { label: "Image", value: "Image" },
      { label: "Video", value: "Video" },
    ],
  },
  {
    model: "slides",
    field: "pictogram",
    options: [
      { label: "None", value: "None" },
      ...pictograms.map((p) => {
        return {
          label: p.name,
          value: p.name,
        };
      }),
    ],
  },
  {
    model: "slides",
    field: "backgroundColor",
    options: [
      { label: "Black", value: "#000000" },
      { label: "Blue", value: "#00E1DC" },
      { label: "Green", value: "#5AF173" },
      { label: "Pink", value: "#FE85B6" },
      { label: "Yellow", value: "#E5FB00" },
    ],
  },
  ...screenTypeDropdowns,
];

interface ICustomField {
  original: string;
  display?: string;
  hint?: string | React.ReactNode;
  optional?: boolean;
  accept?: string;
  modelSpecific?: ICustomFieldModelSpecific[];
  hide?: boolean;
}

interface ICustomFieldModelSpecific {
  modelName: string;
  display?: string;
  hint?: string | React.ReactNode;
  accept?: string;
  optional?: boolean;
  hide?: boolean;
}

/**
 * LWcustom - Modify this array to include model fields that have custom display names and hints on their forms
 */
export const customFieldNames: ICustomField[] = [
  {
    original: "templateCustomItem",
    display: "Template Custom Item",
    hint: "Hints for fields",
    modelSpecific: [
      {
        modelName: "modelName",
        display: "This model's field will be displayed as this name",
        hint: "This model will get this hint",
      },
    ],
  },
  {
    original: "createdAt",
    display: "Created",
  },
  {
    original: "updatedAt",
    display: "Updated",
  },
  {
    original: "editedBy",
    display: "Last edited by",
    optional: true,
    hide: true,
  },
  {
    original: "publishedAt",
    display: "Published at",
  },
  {
    original: "type",
    modelSpecific: [
      {
        modelName: "studentworks",
        optional: false,
      },
      {
        modelName: "schoolphotos",
        optional: false,
      },
    ],
  },
  {
    original: "duration",
    display: "Duration (seconds)",
  },
  {
    original: "displayDates",
    display: "Display Dates",
    hint: "Select a date range to show this slide only between certain dates. To have a slide always shown, leave this field blank or click Clear dates.",
  },
  {
    original: "videoUrl",
    display: "Video",
    optional: false,
    modelSpecific: [
      {
        modelName: "slides",
        hint: "Must be an optimised/compressed H.264 MP4 file, 7680 x 1080px",
      },
    ],
  },
  {
    original: "imageUrl",
    display: "Image",
    optional: false,
    hint: "Must be a JPG or PNG file, landscape format, 3840 x 2160px",
    modelSpecific: [
      {
        modelName: "slides",
        hint: "Must be a JPG or PNG file, landscape format, 7680 x 1080px",
      },
      {
        modelName: "studentworks",
        optional: true,
      },
      {
        modelName: "schoolphotos",
        optional: false,
      },
    ],
  },
  {
    original: "donorList",
    display: "Donor List",
    hint: "Add or remove donors",
  },
  {
    original: "caption",
    display: "Text",
    modelSpecific: [
      {
        modelName: "slides",
        optional: false,
      },
      {
        modelName: "studentworks",
        hint: "Max. 5 words",
      },
      {
        modelName: "schoolphotos",
        hint: "Max. 5 words",
      },
    ],
  },
  {
    original: "name",
    display: "Username",
  },
  {
    original: "backgroundColor",
    display: "Background Color",
  },
  {
    original: "user_role",
    display: "Account Type",
    hint: (
      <>
        <div>Select an account type from the dropdown.</div>
        <div>
          Administrators can manage user accounts, and add, edit and delete
          content.
        </div>
        <div>
          Editors can add, edit and delete content, but cannot manage user
          accounts.
        </div>
      </>
    ),
  },
];
